var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"ma-2",attrs:{"color":_vm.color,"text-color":"white","variant":"flat"}},[_c('v-icon',{attrs:{"left":"","title":_vm.title}},[_vm._v(_vm._s(_vm.speed.toFixed(1))+" km/h")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }